import { FONTS, GRAD, PINK, CARD_BORDER, CARD_BG } from "../data/affirmations";

interface ZonesTabProps {
  onSelectZone: () => void;
}

export function ZonesTab({ onSelectZone }: ZonesTabProps) {
  const zones = [
    {
      zone: "North London",
      areas: "Camden · Islington · Tottenham",
      drops: ["The Amy Walk", "The Adele Walk"],
      bg: "#FFF0F8",
      border: "#FFD6EC",
      accent: PINK,
      tag: "NW · N",
    },
    {
      zone: "West London",
      areas: "Notting Hill · Hammersmith · Kensington",
      drops: ["The Notting Hill Strut", "The Fleabag Route", "The Crown Walk"],
      bg: "#F0FFF4",
      border: "#C8E6C9",
      accent: "#0A7C5E",
      tag: "W · SW",
    },
    {
      zone: "South London",
      areas: "Borough · Southwark · Brixton",
      drops: ["The Bridget Jones Walk"],
      bg: "#FFF8F0",
      border: "#FFD9A8",
      accent: "#B5621E",
      tag: "SE · SW",
    },
    {
      zone: "East London",
      areas: "Shoreditch · Hackney · Bethnal Green",
      drops: ["The Shoreditch Strut", "The Eastenders Walk"],
      bg: "#F3F0FF",
      border: "#D9D0F5",
      accent: "#5B45D4",
      tag: "E · EC",
    },
  ];

  return (
    <div style={{ animation: "fadeUp 0.4s ease" }}>
      <style>{FONTS + `@keyframes fadeUp { from { opacity:0;transform:translateY(16px) } to { opacity:1;transform:translateY(0) } }`}</style>

      <div style={{ marginBottom: "20px" }}>
        <div style={{ fontSize: "9px", letterSpacing: "5px", color: PINK, textTransform: "uppercase", fontWeight: 700, fontFamily: "'Poppins',sans-serif", marginBottom: "4px" }}>explore by area</div>
        <div style={{ fontFamily: "'Poppins',sans-serif", fontSize: "28px", fontWeight: 900, color: "#1a1a1a", letterSpacing: "-1px", lineHeight: 1 }}>London Zones</div>
      </div>

      {zones.map(zone => (
        <div
          key={zone.zone}
          onClick={onSelectZone}
          style={{ background: "#fff", border: `1px solid ${zone.border}`, borderRadius: "18px", overflow: "hidden", marginBottom: "10px", cursor: "pointer" }}>
          <div style={{ height: "3px", background: zone.accent }} />
          <div style={{ padding: "16px 18px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "10px" }}>
              <div>
                <div style={{ fontFamily: "'Poppins',sans-serif", fontWeight: 800, fontSize: "19px", color: "#1a1a1a", marginBottom: "2px" }}>{zone.zone}</div>
                <div style={{ fontSize: "11px", color: "#999", fontFamily: "'Poppins',sans-serif" }}>{zone.areas}</div>
              </div>
              <span style={{ background: zone.bg, color: zone.accent, fontSize: "9px", fontWeight: 700, padding: "4px 10px", borderRadius: "50px", fontFamily: "'Poppins',sans-serif", border: `1px solid ${zone.border}` }}>{zone.tag}</span>
            </div>
            <div style={{ paddingTop: "10px", borderTop: `1px solid ${zone.border}` }}>
              <div style={{ fontSize: "9px", color: "#bbb", letterSpacing: "2px", textTransform: "uppercase", marginBottom: "6px", fontFamily: "'Poppins',sans-serif" }}>routes here</div>
              {zone.drops.map((d, i) => (
                <div key={i} style={{ fontSize: "12px", color: zone.accent, padding: "2px 0", fontFamily: "'Poppins',sans-serif", fontWeight: 600 }}>· {d}</div>
              ))}
            </div>
          </div>
        </div>
      ))}

      {/* GPS teaser */}
      <div style={{ background: CARD_BG, border: `1px solid ${CARD_BORDER}`, borderRadius: "16px", padding: "20px", textAlign: "center" }}>
        <div style={{ fontSize: "28px", marginBottom: "8px" }}>📍</div>
        <div style={{ fontFamily: "'Poppins',sans-serif", fontWeight: 800, fontSize: "16px", color: "#1a1a1a", marginBottom: "4px" }}>GPS Navigation Coming Soon</div>
        <div style={{ fontSize: "12px", color: "#999", fontFamily: "'Poppins',sans-serif" }}>Turn-by-turn as you walk · Premium feature</div>
      </div>
    </div>
  );
}
